import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SidebarService} from '../shared/services/sidebar.service';
import 'rxjs/add/operator/filter';
import {AuthTokenService} from '../shared/services/auth-token.service';
import {PreviousUrlService} from '../shared/services/previous-url.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit, AfterViewChecked, OnDestroy {
  notification = false;
  profile = false;
  userInfo: any;
  surveyTitle: string;
  translationTitle: string;
  isAdmin: boolean;
  isCustomerAdmin: boolean;
  isCommon: boolean;
  destroyed = false;
  isShowWordCloud = AuthTokenService.isShowWordCloud();

  @Input()
  collapsedSidebar;


  constructor(public router: Router,
              public _sidebarService: SidebarService,
              private route: ActivatedRoute,
              private authTokenService: AuthTokenService,
              private shareService: PreviousUrlService,
              private cdr: ChangeDetectorRef
  ) {
  }


  ngOnInit() {
    if (sessionStorage.getItem('User') !== null) {
      this.userInfo = JSON.parse(sessionStorage.getItem('User'));

    }


    this.isAdmin = AuthTokenService.isAdmin();
    this.isCommon = AuthTokenService.isUser();
    this.isCustomerAdmin = AuthTokenService.isCustomerAdmin();

    this.shareService.titleChanges.subscribe(title => {
      this.surveyTitle = title;
      if (!this.destroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewChecked() {
    this.surveyTitle = this.shareService.getSurveyTitle();
    this.translationTitle = this.shareService.getTranslationTitle();
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
      this.cdr.detach();
      this.destroyed = true;
  }

  openNotification() {
    this.notification = !this.notification;
  }

  userProfile() {
    this.profile = !this.profile;
  }

  editProfile() {
    this.router.navigateByUrl('users/edit/' + this.userInfo.user.id);
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.notification = false;
    }
  }

  onClickOutsideProfile(event: Object) {
    if (event && event['value'] === true) {
      this.profile = false;
    }
  }

  logout() {
    this.authTokenService.logout();
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts